import { render, staticRenderFns } from "./AttachmentThumbnails.vue?vue&type=template&id=2c373e15&scoped=true&"
import script from "./AttachmentThumbnails.vue?vue&type=script&lang=ts&"
export * from "./AttachmentThumbnails.vue?vue&type=script&lang=ts&"
import style0 from "./AttachmentThumbnails.vue?vue&type=style&index=0&id=2c373e15&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c373e15",
  null
  
)

export default component.exports